<template>
    <vx-table-row>
        <vx-table-row-item class="hidden xl:inline-block">
            <vx-checkbox v-model="selected" :aria-label="selectLabel" data-test="select"></vx-checkbox>
        </vx-table-row-item>

        <vx-table-row-title class="xl:col-span-2!">
            <div class="flex items-center gap-2">
                <vx-checkbox
                    v-model="selected"
                    :aria-label="selectLabel"
                    data-test="select"
                    class="md:inline-flex xl:hidden"
                ></vx-checkbox>
                <span>{{ fullName }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Phone: </template>
            {{ formatPhoneNumber(props.modelValue.phone) }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Email: </template>
            {{ props.modelValue.email }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Campaign Sends: </template>
            <span v-if="!belongsToCampaign">-</span>
            <vx-icon-loading v-else-if="loadingCompletedCount" class="w-2 h-2" spn></vx-icon-loading>
            <template v-else>{{ completedCount }}</template>
        </vx-table-row-item>

        <vx-table-row-item v-if="pending" class="justify-center">
            <vx-icon-loading class="w-2 h-2"></vx-icon-loading>
        </vx-table-row-item>

        <vx-table-row-buttons v-else>
            <slot name="buttons">
                <vx-button v-if="belongsToCampaign"
                    @click.prevent="emit('remove')"
                    data-test="remove-btn"
                    color="muted"
                    outline>
                    Remove <font-awesome-icon widthAuto :icon="faCircleMinus" />
                </vx-button>

                <vx-button v-else
                    @click.prevent="emit('add')"
                    data-test="add-btn"
                    color="muted"
                    outline>
                    Add <font-awesome-icon widthAuto :icon="faCirclePlus" />
                </vx-button>
            </slot>
        </vx-table-row-buttons>

    </vx-table-row>
</template>

<script setup>
import {  faCirclePlus, faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxIconLoading,
    VxCheckbox,
} from '@voxie/frontend-components';
import { contactsClient } from '~/services';
import { computed, ref, watch } from 'vue';
import { displayContactName, formatPhoneNumber } from '~/components/filters';

const selected = defineModel('selected', {
        type: Boolean,
        required: true,
    }
);

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    campaignId: {
        type: Number,
        required: true,
    },
    pending: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['add', 'remove']);

const fullName = computed(() => {
    const fullName = `${props.modelValue.first_name || ''} ${props.modelValue.last_name || ''}`.trim();
    return fullName || '-';
})

const selectLabel = computed(() => `Select ${displayContactName(props.modelValue)}`);

const belongsToCampaign = computed(() => {
    return props.modelValue.campaigns?.filter(campaign => campaign.id === props.campaignId)?.length > 0;
});

const loadingCompletedCount = ref(false);
const completedCount = ref(0);

watch(belongsToCampaign, () => {
    if (belongsToCampaign.value) {
        loadingCompletedCount.value = true;
        contactsClient.contactsCompletedCount(props.modelValue.team_id, props.campaignId, props.modelValue.id)
            .then(({ data }) => {
                completedCount.value = data.count;
            })
            .finally(() => {
                loadingCompletedCount.value = false;
            });
    }
}, {
    immediate: true
})

</script>
